import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'servicios/';
const API_PUBLIC_URL = 'servicios-public/';
export interface Sucursal {
    id: number;
    nombre: string;
    direccion: string;
    codigo: string;
    telefono: string;
    email: string;
    activo: boolean;
    fecha_creacion: string;
}
export interface Servicio {
    id: number;
    categoria: number;
    categoria_nombre: string;
    nombre: string;
    descripcion: string;
    imagen: string | null;
    estado: boolean;
    fecha_creacion: string;
    tipo_servicio?: 'orden_servicio' | 'oficina_virtual';
    requiere_espacio: boolean;
    codigo_producto_sin: string;
    codigo_unidad_medida_sin: number;

    sucursales: Sucursal[];
}
export interface ServicioFormData {
    categoria: number;
    nombre: string;
    descripcion?: string;
    imagen?: File | null;
    estado: boolean;
    tipo_servicio?: 'orden_servicio' | 'oficina_virtual';
    requiere_espacio: boolean;
    codigo_producto_sin: string;
    codigo_unidad_medida_sin: number;
    sucursales: number[];
}


export const fetchServicios = async (): Promise<Servicio[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const createServicio = async (data: ServicioFormData) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();

        formData.append('categoria', data.categoria.toString());
        formData.append('nombre', data.nombre);
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());
        formData.append('tipo_servicio', data.tipo_servicio || 'orden_servicio');
        formData.append('requiere_espacio', (data.tipo_servicio === 'oficina_virtual' ? false : data.requiere_espacio).toString());
        formData.append('codigo_producto_sin', data.codigo_producto_sin);
        formData.append('codigo_unidad_medida_sin', data.codigo_unidad_medida_sin.toString());
        data.sucursales.forEach((id) => {
            formData.append('sucursales', id.toString());
        });
        const response = await axiosInstance.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    });
};

export const updateServicio = async (
    id: number,
    data: ServicioFormData
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        formData.append('categoria', data.categoria.toString());
        formData.append('nombre', data.nombre);
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());
        formData.append('tipo_servicio', data.tipo_servicio || 'orden_servicio');
        formData.append('requiere_espacio', (data.tipo_servicio === 'oficina_virtual' ? false : data.requiere_espacio).toString());
        formData.append('codigo_producto_sin', data.codigo_producto_sin);
        formData.append('codigo_unidad_medida_sin', data.codigo_unidad_medida_sin.toString());
        data.sucursales.forEach((id) => {
            formData.append('sucursales', id.toString());
        });
        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    });
};

export const deleteServicio = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};

export const fetchServiciosByCategory = async (
    categoriaId: number
): Promise<Servicio[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_PUBLIC_URL, {
            params: {
                categoria: categoriaId,
                estado: true,
            },
        });
        return response.data;
    });
};

export const fetchSucursalesActivas = async (): Promise<Sucursal[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get('sucursales/', {
            params: { activo: true },
        });
        return response.data;
    });
};


